import React from 'react';
import '../styles/Services.css';
import eorImage from '../assets/service-eor.png';
import immigrationImage from '../assets/service-immigration.png';
import recruitmentImage from '../assets/service-recruitment.png';

export default function Services() {
  return (
    <div className="services-page container py-5">
      <h1>Our Services</h1>

      <div className="row gy-5">
        {/* EOR Service */}
        <div className="col-lg-4">
          <div className="service-card h-100 shadow-sm p-4 rounded bg-white text-center">
            <img src={eorImage} alt="Employer of Record" className="service-image mb-3" />
            <h3 className="h5 fw-semibold text-dark mb-3">Employer of Record (EOR)</h3>
            <p>
              Grow your team in Malaysia without setting up a legal entity. Reans acts as your local employer and handles:
            </p>
            <ul className="list-unstyled text-start mt-3">
              <li><i className="bi bi-file-earmark-text-fill text-success me-2"></i> Compliant employment contracts</li>
              <li><i className="bi bi-card-checklist text-success me-2"></i> EPF, SOCSO, EIS & PCB registration</li>
              <li><i className="bi bi-cash-stack text-success me-2"></i> Monthly payroll & statutory contributions</li>
              <li><i className="bi bi-person-badge-fill text-success me-2"></i> End-to-end HR support</li>
              <li><i className="bi bi-shield-check text-success me-2"></i> Employment Act 1955 compliance</li>
            </ul>
          </div>
        </div>

        {/* Immigration Service */}
        <div className="col-lg-4">
          <div className="service-card h-100 shadow-sm p-4 rounded bg-white text-center">
            <img src={immigrationImage} alt="Immigration Services" className="service-image mb-3" />
            <h3 className="h5 fw-semibold text-dark mb-3">Immigration Services</h3>
            <p>
              We streamline expatriate onboarding with full-service immigration support.
            </p>
            <ul className="list-unstyled text-start mt-3">
              <li><i className="bi bi-airplane-engines text-info me-2"></i> Employment, Visit & Dependent Passes</li>
              <li><i className="bi bi-journal-check text-info me-2"></i> Visa filing, renewals & follow-ups</li>
              <li><i className="bi bi-clock-history text-info me-2"></i> Real-time application tracking</li>
              <li><i className="bi bi-check2-square text-info me-2"></i> Custom checklists & advisory</li>
            </ul>
          </div>
        </div>

        {/* Recruitment Service */}
        <div className="col-lg-4">
          <div className="service-card h-100 shadow-sm p-4 rounded bg-white text-center">
            <img src={recruitmentImage} alt="Recruitment Solutions" className="service-image mb-3" />
            <h3 className="h5 fw-semibold text-dark mb-3">Recruitment Solutions</h3>
            <p>
              We help you hire the best talent fast across Malaysia and the region.
            </p>
            <ul className="list-unstyled text-start mt-3">
              <li><i className="bi bi-search text-warning me-2"></i> Tailored CV matching & screening</li>
              <li><i className="bi bi-person-fill-check text-warning me-2"></i> Contract & executive placements</li>
              <li><i className="bi bi-lightning-fill text-warning me-2"></i> Fast turnaround hiring process</li>
              <li><i className="bi bi-globe-asia-australia text-warning me-2"></i> Local & regional sourcing</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
